import { AnyAction } from "redux";

import slice from "../reducer/slice";

type TOperation = (hasActions: boolean) => AnyAction;

const operation: TOperation = (hasActions) => slice.actions.setHasActions(hasActions);

export default operation;
